import React,{useState} from 'react'
import ToastMessage from './toast-message'

export default function ToastMessageFunction() {
    const [toastData,setToastData]=useState({});
    const [isOpen,setIsOpen]=useState(false);

    const getToast =(message,severity)=>{
        setToastData({message,severity});
        setIsOpen(true);
    }
    const onClose=(c)=>{setIsOpen(c)};

    const toast =<ToastMessage open={isOpen} toastData={toastData} onClose={onClose}/>

  return {
    getToast,
    toast
  }
}
